module.exports = __webpack_public_path__ + "static/btn_024.1bbb9492.png";